<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">
          {{ label }}
        </h1>
      </template>
      <template #actions>
        <page-header-action
          tag="form-button"
          v-if="identifier"
          :indicator="downloading"
          @clicked="download"
        >
          Download Invoice
        </page-header-action>
      </template>
    </page-header>
    <div class="card" v-if="!loading">
      <div class="card-body">
        <div v-if="!selectedIncident">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="control-label text-left">Claim Reference:</label>
                <input
                  name="terms"
                  type="text"
                  class="form-control"
                  v-model="claim_reference"
                />
              </div>
              <form-button
                class="btn btn-primary btn-block"
                :indicator="searching"
                @clicked="search"
              >
                Search
              </form-button>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table margin-t-10" v-if="!searching && incidents">
              <thead>
                <tr>
                  <th>Claim Reference</th>
                  <th>Client Name</th>
                  <th>Client Vehicle Registration</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-bind:key="index" v-for="(incident, index) in incidents">
                  <td>
                    {{ incident.source?.claim_reference || 'Not Available' }}
                  </td>
                  <td>{{ incident.client?.full_name || 'Not Available' }}</td>
                  <td>
                    {{
                      incident.client?.vehicle?.registration || 'Not Available'
                    }}
                  </td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="selectIncident(incident)"
                    >
                      Select
                    </button>
                  </td>
                </tr>

                <tr v-if="!incidents.length">
                  <td class="text-center" colspan="7">
                    No claims found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="form-group" v-if="selectedIncident">
          <div class="col-lg-4 has-helper">
            <label class="control-label">
              Incident:
            </label>
          </div>

          <div class="col-lg-8">
            <div class="card mb-3">
              <div class="card-body">
                <div class="float-left" style="margin-top: 8px;">
                  Claim Reference :
                  {{ selectedIncident.source?.claim_reference }} - Client :
                  {{ selectedIncident.client?.full_name || 'Not Available' }} -
                  Vehicle Reg:
                  {{
                    selectedIncident.client?.vehicle?.registration ||
                      'Not Available'
                  }}
                </div>
                <div class="float-right">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="clearIncident"
                    v-if="!identifier"
                  >
                    Change Incident
                  </button>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" v-if="!!recharge">
          <div class="col-lg-4">
            <label class="control-label">Invoice Number:</label>
          </div>
          <div class="col-lg-8">
            {{ recharge.invoice_number }}
          </div>
        </div>

        <div class="table-responsive" v-if="penalties?.length">
          <h4>Penalties</h4>
          <table class="table">
            <thead>
              <tr>
                <th>Claim Reference</th>
                <th>Issuing Authority</th>
                <th>External Reference</th>
                <th>Type</th>
                <th>Vehicle</th>
                <th>Penalty Paid Date</th>
                <th>Settled Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-bind:key="index" v-for="(penalty, index) in penalties">
                <td>{{ penalty.hire?.incident?.source?.claim_reference }}</td>
                <td>
                  {{ penalty.issuing_authority?.name || 'Not Available' }}
                </td>
                <td>{{ penalty.external_reference || 'Not Available' }}</td>
                <td>{{ penalty.penalty_type?.label || 'Not Available' }}</td>
                <td>{{ penalty.vehicle?.registration || 'Not Available' }}</td>
                <td>{{ penalty.penalty_paid_at | date }}</td>
                <td>{{ penalty.settled_date | date }}</td>
                <td>
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="removePenalty(penalty)"
                  >
                    Remove Penalty
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="card-footer text-right">
        <button
          class="btn btn btn-primary"
          type="button"
          v-if="!!identifier"
          v-on:click="openAddPenaltyModal"
        >
          Add Penalty
        </button>

        <form-button @clicked="submit" v-if="!identifier" :indicator="saving">
          <i class="icon icon-save"></i> {{ label }}
        </form-button>

        <v-add-penalty
          :recharge="recharge"
          v-if="modals.add"
          v-on:close="closeAddPenaltyModal"
          v-on:added="penaltyWasAdded"
        ></v-add-penalty>
      </div>
    </div>

    <div v-else>
      <preloader></preloader>
    </div>
  </div>
</template>

<script>
import AddPenalty from './Children/AddPenalty';
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  props: {
    identifier: {
      type: String
    }
  },

  components: {
    PageHeader,
    PageHeaderAction,
    'v-add-penalty': AddPenalty
  },

  data() {
    return {
      modals: {
        add: false,
        edit: false
      },
      loading: true,
      saving: false,
      deleting: false,
      searching: false,
      claim_reference: null,
      incidents: [],
      form: new window.Form({
        incident_id: null,
        client_id: null
      }),
      selectedIncident: null,
      recharge: undefined,
      penalty: undefined,
      downloading: false
    };
  },

  computed: {
    label() {
      return this.identifier ? 'Update Recharge' : 'Create Recharge';
    },

    penalties() {
      return this.$store.getters['Recharges/penalties'];
    }
  },

  mounted() {
    this.$store.commit('Recharges/clearRecord');

    if (this.identifier) {
      this.loading = true;

      window.Ajax.get(
        `recharges/${this.identifier}?parts=incident,penalties`
      ).then(({ data }) => {
        this.recharge = data;

        this.selectIncident(data.incident);

        this.$store.commit('Recharges/setPenalties', data.penalties);
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },

  methods: {
    search() {
      if (this.claim_reference) {
        this.searching = true;

        window.Ajax.get(`/incidents?filter[terms]=${this.claim_reference}`)
          .then(response => {
            this.incidents = response.data;
            this.searching = false;
          })
          .catch(error => {});
      }
    },

    submit() {
      if (this.identifier) {
        this.update();
      } else {
        this.create();
      }
    },

    addPenalty() {
      window.Ajax.put(`/recharges/${this.recharge.identifier}/add-penalty`, {
        penalty_id: 1
      }).then(({ data }) => {
        window.toastify.success('Saved!', 'The job was saved successfully');
      });
    },

    create() {
      this.saving = true;

      window.Ajax.post('recharges', this.form).then(response => {
        this.saving = false;
        this.recharge = response.data;

        window.toastify.success(
          'Recharge Created',
          'The recharge was created successfully!'
        );

        this.route(`/recharges/${this.recharge.identifier}/edit`);
      });
    },

    update() {
      // this.saving = false;
      // window.Ajax.put(`recharges/${this.identifier}`, this.form)
      //     .then(response => {
      //       this.saving = false;
      //       this.recharge = response.data;
      //       window.toastify.success(
      //           'Recharge Updated',
      //           'The recharge was updated successfully!'
      //       );
      //     });
    },

    removePenalty(penalty) {
      window
        .swal({
          title: 'Are you sure?',
          text: 'Are you sure you want to remove that penalty?',
          type: 'warning',
          showCancelButton: true
        })
        .then(() => {
          window.Ajax.put(
            `/recharges/${this.recharge.identifier}/remove-penalty`,
            { penalty_id: penalty.id }
          )
            .then(() => {
              this.$store.commit('Recharges/removePenalty', penalty.identifier);

              window.toastify.success('Removed', 'The penalty was removed!');
            })
            .catch(err => {
              window.toastify.error(
                'Error',
                'Oops, there was an error deleting the penalty'
              );
            });
        })
        .catch(err => {});
    },

    getIncident(recharge) {
      window.Ajax.get(`/incidents/${recharge.incident.identifier}`)
        .then(response => {
          this.selectIncident(response.data);
        })
        .catch(error => {});
    },

    selectIncident(incident) {
      this.form.incident_id = incident.id;
      this.form.client_id = incident.client?.id;
      this.selectedIncident = incident;
    },

    clearIncident() {
      this.form.incident_id = null;
      this.form.client_id = null;
      this.selectedIncident = null;
    },

    openAddPenaltyModal() {
      this.modals.add = true;
    },

    closeAddPenaltyModal() {
      this.modals.add = false;
    },

    penaltyWasAdded(recharge) {
      this.$store.commit('Recharges/setPenalties', recharge.penalties);

      this.closeAddPenaltyModal();
      this.$emit('updated', true);

      window.toastify.success(
        'Success!',
        'The penalty was added successfully!'
      );
    },

    download() {
      this.downloading = true;
      if (this.identifier) {
        let url = `/recharges/${this.identifier}/download`;

        window.Ajax.download(url)
          .then(() => {
            this.downloading = false;
          })
          .catch(error => {
            this.downloading = false;
            window.toastify.error(
              'Error',
              'There was a problem downloading the invoice, please try again.'
            );
          });
      }
    }
  }
};
</script>
